import { formatPublishDate } from 'utils/conversions'

export const getUGCStyles = () => {
  return [
    {
      bgColor: 'bg-[#14419A]',
      textColor: 'text-neutral-0',
    },
    {
      bgColor: 'bg-yellow-500',
      textColor: 'text-[#000F66]!',
    },
    {
      bgColor: 'bg-green-600',
      textColor: 'text-neutral-0',
    },
    {
      bgColor: 'bg-[#2C70E3]',
      textColor: 'text-neutral-0',
    },
    {
      bgColor: 'bg-[#14419A]',
      textColor: 'text-neutral-0',
    },
  ]
}

export const getUGCTemplates = (story) => {
  const totalDebtAmount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(story.totalDebtAmount)
  return [
    {
      type: 'select',
      eyebrow: '#BREAKUPWITHDEBT',
      title: 'Let’s review your Freedom Debt Relief journey',
      subtitle: 'Dear debt, it’s over because',
      icon: '/multi-site-assets/confetti.svg',
      options: [
        'I finally chose me',
        'I realized I was rearranging my life just to make minimum payments',
        'I saw a friend get out, and knew I could too',
        'I was sick of you dictating what I could or couldn’t do',
        'I was done counting every single penny ',
      ],
    },
    {
      type: 'boxes',
      eyebrow: `${formatPublishDate(story.startDate)}`,
      title: `I joined ${story.sameDayJoins} others on a mission to get rid of debt. `,
      subtitle: 'How did you feel when you started this journey?',
      icon: '/multi-site-assets/map.svg',
      options: ['hopeful', 'motivated', 'committed', 'scared', 'empowered', 'supported'],
    },
    {
      type: 'select',
      eyebrow: `${formatPublishDate(story.dateOfFirstSettlement)}`,
      title: 'You kicked your 1st debt to the curb!',
      subtitle: `${story.daysToFirstResolution} days later, I told my 1st debt,`,
      icon: '/multi-site-assets/calendar_dollar.svg',
      options: [
        "It's not me, it's you (and your 24% interest rate)",
        "We're over. I need space in my budget",
        'Consider this your eviction notice',
        'Thank you, next',
        'So long, farewell',
      ],
    },
    {
      type: 'select',
      eyebrow: 'YOU PAID OFF...',
      title: 'It took consistency, patience, and sticking to the plan. ',
      subtitle: `In just ${story.totalMonths} months, I traded ${story.totalResolvedDebts} debts for`,
      icon: '/multi-site-assets/time.svg',
      options: [
        'confidence in my choices',
        'boundaries and better sleep',
        'a glow-up and a fresh start',
        'new habits and no guilt',
        'breathing room',
        'a life that feels mine again',
      ],
    },
    {
      type: 'select',
      eyebrow: `${formatPublishDate(story.endDate)}`,
      title: `Your enrolled debt is finally in your past!`,
      subtitle: `Now that ${totalDebtAmount} is behind me, I can`,
      icon: '/multi-site-assets/confetti.svg',
      options: [
        'build a future my family can count on',
        'save for the down payment on my first home ',
        'help my parents retire without worry',
        'walk into a room without feeling like I’m hiding something',
      ],
    },
  ]
}
